
import  article1 from '../images/articles/article1.png'
import article2 from '../images/articles/south.png'
import article3 from '../images/articles/West.png'
import article4 from '../images/articles/north.png'


export const Articles = [
    {
        articleID:'1',
        title:'What are the reasons to visit the Kokan?',
        img: article1
      
    },
    {
        articleID:'2',
        title:'What are the resions to visit South India?',
        img: article2
    
    },
    {
        articleID:'3',
        title:'What are the reasons to visit the west india?',
        img: article3
       
    },
    {
        articleID:'4',
        title:'What are the reasons to visit the North india?',
        img: article4
       
    },
]